import React from "react";
import { Container } from "../../components/common";

export interface CTASectionProps {
  title?: string;
}

const CTA_DEFAULTS = {
  title: 'Trusted sharing. Clear responsibility. Stronger community.',
};

export const CTASection: React.FC<CTASectionProps> = ({ title }) => {
  const heading = title?.trim() || CTA_DEFAULTS.title;
  return (
    <section className="relative overflow-hidden mb-8">
      <Container className="relative">
        <div className="bg-v2-green-600 py-8 lg:py-10 px-6 sm:px-8 rounded-v2-xl">
          <div className="flex flex-col gap-8 lg:grid lg:grid-cols-[minmax(0,1fr)_auto] lg:items-start xl:gap-x-12">
            <div className="min-w-0">
              <h2 className="font-sora text-center text-[1.875rem] font-bold text-white leading-[1.2] tracking-[-0.015em]">
                {heading}
              </h2>
            </div>
          </div>
        </div>
      </Container>
    </section>
  );
};
